import { render, staticRenderFns } from "./FormLoja.vue?vue&type=template&id=93a4a0d4"
import script from "./FormLoja.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormLoja.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports